import { CommonNS } from "../../../../Common/CommonNS.js";
import { ViewBoxNS } from "../../../../ViewBox/ViewBoxNS.js";
import { ViewPortNS } from "../../../../ViewPort/ViewPortNS.js";
import { VONS } from "../../VO/VONS.js";
export class PointSizeController {
  constructor({ svg_el, getCTM, outer_size, inner_size, view_port, view_box }) {
    this._observer_set = new Set();
    this._svg_el = svg_el;
    this._getCTM = getCTM;
    this._outer_size = outer_size;
    this._inner_size = inner_size;
    this._point_size_vo = {
      outer_size: 0,
      inner_size: 0,
    };
    this._updatePointSizeVO();
    view_port.subscribe(() => this._observeViewPortOrViewBox());
    view_box.subscribe(() => this._observeViewPortOrViewBox());
  }
  subscribe(observer) {
    if (this._observer_set.has(observer)) {
      throw new Error(`이미 등록된 observer 입니다.`);
    }
    observer(this._point_size_vo);
    this._observer_set.add(observer);
    return () => {
      this._observer_set.delete(observer);
    };
  }
  _observeViewPortOrViewBox() {
    this._updatePointSizeVO();
    this._notify(this._point_size_vo);
  }
  _notify(point_size_vo) {
    for (const observer of this._observer_set) {
      CommonNS.UtilNS.tryNoop(() => observer(point_size_vo));
    }
  }
  _updatePointSizeVO() {
    const ctm_inverse = this._getCTM().inverse();
    const origin_point = CommonNS.UtilNS.createSVGPoint(this._svg_el)([
      0, 0,
    ]).matrixTransform(ctm_inverse);
    const outer_size_point = CommonNS.UtilNS.createSVGPoint(this._svg_el)([
      this._outer_size,
      0,
    ]).matrixTransform(ctm_inverse);
    const inner_size_point = CommonNS.UtilNS.createSVGPoint(this._svg_el)([
      this._inner_size,
      0,
    ]).matrixTransform(ctm_inverse);
    this._point_size_vo = {
      outer_size: Math.sqrt(
        (origin_point.x - outer_size_point.x) ** 2 +
          (origin_point.y - outer_size_point.y) ** 2
      ),
      inner_size: Math.sqrt(
        (origin_point.x - inner_size_point.x) ** 2 +
          (origin_point.y - inner_size_point.y) ** 2
      ),
    };
  }
}
